import React from "react"

import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"

import * as styles from "./newsletter-partner.module.scss"

const NewsletterPartner = ({ section, dictionary, secondary }) =>
  section.partner ? (
    <div
      className={`${styles.partner} ${!secondary ? styles.partner__feature : ""}`}
    >
      <div className={styles.partnerPrefix}>
        {section.partner.prefix ||
          dictionary.find(
            (item) => item.key.current === section.campaign_partner_type
          )?.value ||
          dictionary.find((item) => item.key.current === "partner_feature")
            ?.value}
      </div>
      {section.partner.logo ? (
        <a href={section.partner_url || section.partner.url}>
          <Image
            {...section.partner.logo}
            className={styles.partnerImage}
            width={60}
          />
        </a>
      ) : (
        section.partner.name
      )}
    </div>
  ) : (
    ""
  )

export default NewsletterPartner

NewsletterPartner.propTypes = {
  section: PropTypes.object.isRequired,
  dictionary: PropTypes.object.isRequired,
  secondary: PropTypes.bool,
}

NewsletterPartner.defaultProps = {
  secondary: false,
}
